import {
  BIWEEKLY_PAY_PERIOD,
  MONTHLY_PAY_PERIOD,
  TWICE_PER_MONTH_PAY_PERIOD,
  WEEKLY_PAY_PERIOD,
} from '~/app_constants';
import { isEmpty } from 'lodash-es';

export const PAY_PERIOD_VALIDATION_ERROR = 'Complete the pay period start selection before saving';

export function validatePayPeriodState(state = {}) {
  const payPeriodId = String(state.payPeriodId ?? '');

  switch (payPeriodId) {
    case WEEKLY_PAY_PERIOD:
      return state.periodWeekDay == null ? PAY_PERIOD_VALIDATION_ERROR : null;

    case BIWEEKLY_PAY_PERIOD:
      if (state.periodWeekDay == null) {return PAY_PERIOD_VALIDATION_ERROR;}
      if (isEmpty(state.periodAnchorDate)) {return PAY_PERIOD_VALIDATION_ERROR;}

      return null;
    case MONTHLY_PAY_PERIOD:
      return state.periodStartDay == null ? PAY_PERIOD_VALIDATION_ERROR : null;
    case TWICE_PER_MONTH_PAY_PERIOD:
      return state.periodStartDay == null || state.periodSecondStartDay == null ? PAY_PERIOD_VALIDATION_ERROR : null;
    default:
      return null;
  }
}
